export const RESERVED_COLUMNS = new Set([
  // physical patients_with_ehrid columns
  'ehr_id', 'patient_name', 'email', 'phone_numbers', 'visit_dates', 'source_record_ids', 'created_at',
  // wizard transform internal row keys — reusing one as an extra column would
  // clobber a parsed field (and name+DOB dedup) or send an unknown column.
  'dob', 'tel_num', 'type', 'physician_name', 'name_first', 'name_middle', 'name_last',
]);

// Reduce an arbitrary header to a safe Postgres identifier (lowercase, snake_case,
// letter-initial, <= 63 chars). Returns '' when nothing usable remains.
export function sanitizeColumnName(raw) {
  let s = String(raw == null ? '' : raw).toLowerCase().trim();
  s = s.replace(/[^a-z0-9]+/g, '_').replace(/^_+|_+$/g, '');
  if (!s) return '';
  if (!/^[a-z]/.test(s)) s = `col_${s}`;
  return s.slice(0, 63);
}
